import { css } from "@compiled/react";
import { useIntl } from "react-intl";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";

import { templateKeyFeaturesSectionContentfulRelayFragment$key } from "@/__generated_contentful__/templateKeyFeaturesSectionContentfulRelayFragment.graphql";

import { getIcon } from "../../../template-details-page/feature-icon-map";

export type TemplateKeyFeaturesSectionProps = {
    template: templateKeyFeaturesSectionContentfulRelayFragment$key;
};

const keyFeaturesStyles = css({
    paddingBlockStart: "32px"
});

const headingStyles = css({
    // FIXME: GWP-3063: Disabling instead of fixing so we don't deviate from the control visually.
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#505F79",
    fontSize: ".75rem",
    fontWeight: 400,
    letterSpacing: "1px",
    marginBlockEnd: "8px"
});

const featureStyles = css({
    alignItems: "center",
    // FIXME: GWP-3063: Disabling instead of fixing so we don't deviate from the control visually.
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#172B4D",
    display: "flex",
    height: "40px",
    paddingBlockStart: "8px"
});

const featureTextStyles = css({
    marginInlineStart: "14px"
});

const TemplateKeyFeaturesSectionFragment = graphql`
    fragment templateKeyFeaturesSectionContentfulRelayFragment on ProductTemplate {
        keyFeaturesCollection {
            items {
                featureNameExternal
            }
        }
    }
`;

// TODO: will get features from template
export const TemplateKeyFeaturesSection = ({
    template
}: TemplateKeyFeaturesSectionProps) => {
    const data = useFragment(TemplateKeyFeaturesSectionFragment, template);
    const keyFeatures = data?.keyFeaturesCollection?.items || [];
    const intl = useIntl();

    // TODO: temp placeholder data for UI purposes
    const features = keyFeatures ?? [];

    const headingText = intl.formatMessage({
        id: "ConfluenceTemplateMessages.keyFeatures.heading",
        defaultMessage: "KEY FEATURES"
    });

    return (
        !!features.length && (
            <section css={keyFeaturesStyles}>
                <h5 css={headingStyles}>{headingText}</h5>
                {features
                    .filter((feature) => feature?.featureNameExternal != null)
                    .map((feature) => (
                        <div
                            css={featureStyles}
                            key={feature?.featureNameExternal}
                        >
                            {getIcon(feature?.featureNameExternal ?? "")}
                            <span css={featureTextStyles}>
                                {feature?.featureNameExternal}
                            </span>
                        </div>
                    ))}
            </section>
        )
    );
};

export default TemplateKeyFeaturesSection;
